import { Control, FieldValues, UseFormReset, UseFormSetValue } from 'react-hook-form';
import { FilterGroup, RegisterType } from 'types';

import { Headline } from 'components/Headline';
import { Info } from 'components/Info';

import { useFilters } from './Filters.hooks';
import * as S from './Filters.styles';

type FiltersProps = {
  filters: FilterGroup[];
  onSubmit: () => void;
  type?: string;
  reset: UseFormReset<FieldValues>;
  register: RegisterType;
  children?: React.ReactNode;
  control?: Control;
  info?: string;
  defaultValues?: URLSearchParams;
  setValue: UseFormSetValue<FieldValues>;
  isLoading: boolean;
  title?: string;
};

const defaultProps: Partial<FiltersProps> = {
  info: undefined,
  control: undefined,
  children: undefined,
};

export function Filters(props: FiltersProps): React.ReactElement {
  const {
    filters,
    info,
    type,
    register,
    onSubmit,
    control,
    reset,
    children,
    setValue,
    defaultValues,
    isLoading,
    title = 'Search',
  } = {
    ...defaultProps,
    ...props,
  };
  const { filtersIntoComponents } = useFilters(
    filters,
    register,
    onSubmit,
    reset,
    setValue,
    isLoading,
    defaultValues,
    control
  );

  return (
    <S.Container>
      <S.Header>
        <Headline fontFamily="LFT Zeno Condensed" fontWeight="bold" scale="xl">
          {type ? `Search ${type}` : title}
        </Headline>

        {children || null}
      </S.Header>

      {info ? <Info isImportant message={info} /> : null}

      <S.Filters>{filtersIntoComponents}</S.Filters>
    </S.Container>
  );
}
